import { Type } from 'class-transformer';
import { ArrayMaxSize, IsArray, IsIn, IsInt, IsUUID, Min, ValidateNested } from 'class-validator';
import { RECALL_LOT_MATCH_REASONS, type RecallLotMatchReason } from './recall.enums';

export class RecallCaseLotSelectionDto {
  @IsUUID()
  lotId!: string;

  @IsIn(RECALL_LOT_MATCH_REASONS)
  matchReason!: RecallLotMatchReason;

  @IsInt()
  @Min(0)
  chainDepth!: number;
}

/** Cap condiviso backend/frontend sulla selezione lotti di un caso. */
export const MAX_RECALL_CASE_LOTS = 500;

/** Sostituisce l'intera selezione lotti di una bozza. */
export class SetRecallCaseLotsDto {
  @IsArray()
  @ArrayMaxSize(MAX_RECALL_CASE_LOTS)
  @ValidateNested({ each: true })
  @Type(() => RecallCaseLotSelectionDto)
  lots!: RecallCaseLotSelectionDto[];
}
